import type { HateoasLink, HateoasLinks } from '@shared/types/hateoas.types';

const linksByResource = new Map<string, HateoasLinks>();

export const linkRegistry = {
  store(resourceType: string, links: HateoasLinks): void {
    linksByResource.set(resourceType, links);
  },

  merge(resourceType: string, links: HateoasLinks): void {
    linksByResource.set(resourceType, { ...linksByResource.get(resourceType), ...links });
  },

  get(resourceType: string): HateoasLinks | undefined {
    return linksByResource.get(resourceType);
  },

  link(resourceType: string, relation: string): HateoasLink | undefined {
    return linksByResource.get(resourceType)?.[relation];
  },

  has(resourceType: string): boolean {
    return linksByResource.has(resourceType);
  },

  reset(): void {
    linksByResource.clear();
  },
};
